import React from "react"
import classNames from "classnames"
import { renderToStaticMarkup } from "react-dom/server"

import "./Dropdown.scss"
import { DropdownChevron } from "../icon/DropdownChevron"
import { UseFormMethods } from "react-hook-form"

export type DropDownItem = {
  Name: string
  Distance?: string
  Value: string
}

interface DataProps
  extends React.HTMLProps<HTMLSelectElement>,
    Partial<Pick<UseFormMethods, "register" | "errors">> {
  options: DropDownItem[]
}

interface DropdownProps extends DataProps {
  name: string
  testId?: string
  placeholder?: string
  disabled: boolean
  label?: string
  defaultValue?: string
  labelClass?: string
}

const Dropdown = React.forwardRef<HTMLSelectElement, DropdownProps>(
  (props, ref) => {
    const {
      name,
      options,
      testId,
      label,
      placeholder,
      disabled,
      labelClass,
      onChange,
      errors = {},
      defaultValue,
    } = props

    const oneOptionToDisplay = options && options.length === 1
    const dropdownClass = classNames({
      disabled,
      error: errors[name]?.message,
    })

    const stringifySvg = encodeURIComponent(
      renderToStaticMarkup(
        disabled ? (
          <DropdownChevron colour="#051C2C" />
        ) : errors[name]?.message ? (
          <DropdownChevron colour="red" />
        ) : (
          <DropdownChevron colour="#0374D6" />
        )
      )
    )

    return (
      <>
        <div className="dropdown">
          <label className={labelClass} htmlFor={name}>
            {label}
          </label>
          <select
            id={name}
            name={name}
            onChange={onChange}
            data-testid={testId}
            disabled={disabled}
            defaultValue={defaultValue}
            className={`${dropdownClass}`}
            style={{
              backgroundImage: `url('data:image/svg+xml,${stringifySvg}')`,
              backgroundPosition: "right 15px top 50%",
              backgroundRepeat: "no-repeat",
            }}
            ref={ref}
          >
            {placeholder && !oneOptionToDisplay && (
              <option value="">{placeholder}</option>
            )}
            {options?.map((dropDownValue: DropDownItem, index) => {
              const { Name, Distance, Value } = dropDownValue
              return (
                <option
                  key={`${Name}-${index}`}
                  value={Value}
                  selected={Value === defaultValue}
                >
                  {`${Name}${Distance ? " (" + Distance + ")" : ""}`}
                </option>
              )
            })}
          </select>
          {errors[name] && <p>{errors[name].message}</p>}
        </div>
      </>
    )
  }
)

export { Dropdown }
